import { toast } from "react-toastify";
import { FetchLatestNews } from "../../Services/MainServices";


export const FETCH_LATEST_NEWS_REQUEST = "FETCH_LATEST_NEWS_REQUEST";
export const FETCH_LATEST_NEWS_SUCCESS = "FETCH_LATEST_NEWS_SUCCESS";
export const FETCH_LATEST_NEWS_FAILURE = "FETCH_LATEST_NEWS_FAILURE";

// Thunk Action
export const getLatestNewsDetails = () => async (dispatch) => {
  dispatch({ type: FETCH_LATEST_NEWS_REQUEST });

  try {
    const res = await FetchLatestNews();

    const payloadArray = Array.isArray(res?.data?.data)
      ? res.data.data
      : Array.isArray(res?.data)
        ? res.data
        : null;

    if (res?.status === 200 && payloadArray) {
      dispatch({
        type: FETCH_LATEST_NEWS_SUCCESS,
        payload: payloadArray,
      });
    } else {
      const msg = res?.data?.message || "Failed to fetch latest news";
      dispatch({ type: FETCH_LATEST_NEWS_FAILURE, payload: msg });
      // toast.error(msg);
    }
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      toast.error("Session expired. Please login again.");
    } else {
      // toast.error(error?.response?.data?.message || "Something went wrong");
    }
    dispatch({
      type: FETCH_LATEST_NEWS_FAILURE,
      payload:
        error?.response?.data?.message || error.message || "Something went wrong",
    });
  }
};


